export default "__VITE_ASSET__16766185__"